import { Component, OnInit, Input } from '@angular/core';
import { Travel } from 'src/app/models/travel';

@Component({
  selector: 'app-gas-ticket-card',
  templateUrl: './gas-ticket-card.component.html',
  styleUrls: ['./gas-ticket-card.component.css']
})
export class GasTicketCardComponent implements OnInit {
  @Input() lts:number;
  @Input() lts_loaded:number = 0;
  @Input() travel:Travel;
  @Input() reserva:boolean = false;
  @Input() observation:string = '';
  simbol:string = "T";

  constructor() {}

  ngOnInit() {
    this.simbol = this.reserva ? 'R' : 'T';
  }

}
